@if (!staticAlertClosed) {
<ngb-alert #staticAlert type="info" class="pt-0 pb-0 ps-0" (closed)="staticAlertClosed = true">
  <a [routerLink]="url && url !== '' && url !== null ? [url] : []" rel="noopener noreferrer"
    class="p-3 d-block text-decoration-none">{{message}}</a>
</ngb-alert>
}